(function () {
  'use strict';

  /* @ngdoc object
   * @name crewHotacReport
   * @description
   *
   */
  angular
    .module('crewHotacReport', [
      'ui.router'
    ]);
}());
